import { LoginComponent } from './../login/login.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AuthRoutingModule } from './auth-routing.module';
import { NbAuthModule, NbPasswordAuthStrategy, NbAuthSimpleToken, NbAuthJWTToken } from '@nebular/auth';
import {
  NbAlertModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbInputModule,
  NbLayoutModule,
} from '@nebular/theme';
import { SmartRuralAuthCompComponent } from './smart-rural-auth-comp/smart-rural-auth-comp.component';


/**
 * MNódulo que implementa la autenticación
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NbAlertModule,
    NbInputModule,
    NbButtonModule,
    NbCheckboxModule,
    NbCardModule,
    NbLayoutModule,
    AuthRoutingModule,
    NbAuthModule.forRoot({

      strategies :[
        NbPasswordAuthStrategy.setup({
          name: 'email',

          baseEndpoint : 'https://api.smartrural.es:8084/v1',
          login : {
            endpoint :'/login',
            redirect: {
              success: '/pages/dashboard',
              failure: null,
            },
          },
          token :{
            class: NbAuthJWTToken,
            key :'message',
          },

        }),

      ],
      forms:{
        login:{
          strategy: 'email',
        }
      }
    }


    ),
  ],
  declarations: [
    LoginComponent,
    SmartRuralAuthCompComponent,
  ],
})
export class SmartRuralAuthModule{

 }
